module.exports = __webpack_public_path__ + "img/thumb2.64e023e2.png";